class SearchPricingTest {
  constructor() {
    this.eligibleSearchTerms = [
      'hoodie',
      'hoodies',
      'long sleeve',
      'sweatshirt',
      'sweatshirts',
      'comfort colors',
      'gildan'
    ];
    if (this.isEligible()) {
      const flag = Signalman.featureFlag('search_price');
      if (flag === 'test') {
        ProductCatalog.Pricing.fetchOrdQtyPricing(20, 1, 0);
      }
      // this.fireMetrics();
    }
  }

  isEligible() {
    if (
      ProductCatalog.IFrame.isFramed() ||
      !$('.pc-Styles.is-searchResults').length
    ) {
      return false;
    }
    let searchTerm = $('.pc-Styles.is-searchResults').data('search-term');
    searchTerm = searchTerm.toLowerCase().trim();
    return this.eligibleSearchTerms.indexOf(searchTerm) >= 0;
  }

  fireMetrics(flag) {
    return CustomInk.Metrics.fireEvent(
      'testing',
      '2021 2 10 frontier search pricing',
      `2021 2 10 frontier search pricing ${flag}`
    );
  }
}

ProductCatalog.SearchPricingTest = new SearchPricingTest();
